export const environment = {
  production: false,
  apiBaseUrl: 'https://api.silverwise.dev',
  firebase: {
    apiKey: 'AIzaSyBXvfFfvvnTX9-euMBMJrn70qZK6mrtigo',
    authDomain: 'silverwise-dev.firebaseapp.com',
    projectId: 'silverwise-dev',
  },
};
